/* Italian Charms – scripts globaux · assets/ic-global.js (defer)
   1. Montants écrits en euros dans les textes (« Livraison offerte dès 50 € ») :
      convertis dans la devise du visiteur quand il ne paie pas en euros.
      Les prix des produits ne sont pas touchés (Shopify les affiche déjà dans la bonne devise). */
(function () {
  'use strict';
  var c = window.Shopify && Shopify.currency;
  if (!c || !c.active || c.active === 'EUR') return;
  var rate = parseFloat(c.rate) || 1, fmt;
  try { fmt = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: c.active, maximumFractionDigits: 0 }); }
  catch (e) { return; }
  var re = /(?:€\s?(\d+(?:[.,]\d{1,2})?))|(?:(\d+(?:[.,]\d{1,2})?)\s?€)/g;
  var SKIP = 'script,style,textarea,input,[data-no-fx],.price,.price-list,[class*="price"],.money';

  function conv(txt) {
    return txt.replace(re, function (m, a, b) {
      var v = parseFloat(String(a || b).replace(',', '.')) * rate;
      return fmt.format(Math.ceil(v));
    });
  }
  function walk(root) {
    if (!root || !root.nodeType) return;
    var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (n.nodeValue.indexOf('€') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p || p.closest(SKIP)) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var list = [], n;
    while ((n = w.nextNode())) list.push(n);
    list.forEach(function (t) { t.nodeValue = conv(t.nodeValue); });
  }
  function run() { walk(document.body); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  window.addEventListener('load', function () { setTimeout(run, 800); });
  document.addEventListener('shopify:section:load', function (e) { walk(e.target); });
  document.addEventListener('cart:refresh', function () { setTimeout(run, 300); });
})();
